var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 19.5C24.8584 19.5 22.5 21.8584 22.5 24.75C22.5 26.5576 23.4229 28.1631 24.8203 29.1094C22.1455 30.2578 20.25 32.9121 20.25 36H21.75C21.75 32.6777 24.4277 30 27.75 30C31.0723 30 33.75 32.6777 33.75 36H35.25C35.25 32.9121 33.3545 30.2578 30.6797 29.1094C32.0771 28.1631 33 26.5576 33 24.75C33 21.8584 30.6416 19.5 27.75 19.5ZM27.75 21C29.8301 21 31.5 22.6699 31.5 24.75C31.5 26.8301 29.8301 28.5 27.75 28.5C25.6699 28.5 24 26.8301 24 24.75C24 22.6699 25.6699 21 27.75 21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.2959dae59c3b6c85ca26753fd0bfb590.svg";
export { ForwardRef as ReactComponent };